import { DocusealForm } from '@docuseal/react'
import { useEffect, useMemo } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

import { COLOURS } from 'resources'
import { APP_URLS } from 'resources/urls'

import ScreenContainer from 'components/ScreenContainer'

const customCss = `
  #form_container {
    background-color: ${COLOURS.neutralGrey1};
  }

  #minimize_form_button {
    color: ${COLOURS.secondaryPurple1};
  }

  #submit_form_button {
    background-color: ${COLOURS.secondaryPurple1};
  }

  .white-button {
    color: ${COLOURS.secondaryPurple1};
    border-color: ${COLOURS.secondaryPurple1};
  }

  .white-button:hover {
    background-color: ${COLOURS.secondaryPurple1};
    border-color: ${COLOURS.secondaryPurple1};
    color: white;
  }

  .base-button {
    background-color: ${COLOURS.secondaryPurple1};
  }

  .base-button:hover {
    background-color: ${COLOURS.secondaryPurple1};
    opacity: 0.8;
  }

  .bg-base-300 {
    background-color: ${COLOURS.secondaryPurple2};
  }
  .bg-base-content {
    background-color: ${COLOURS.secondaryPurple1};
  }
`

const ProtectSigning = () => {
  const history = useHistory()
  const location = useLocation()

  const docusealSlug = useMemo(() => location.state?.docusealSlug, [location.state?.docusealSlug])

  useEffect(() => {
    if (!docusealSlug) {
      history.replace(APP_URLS.PROTECT)
    }
  }, [docusealSlug, history])

  const goToSubmittedScreen = () => {
    history.replace(`${APP_URLS.PROTECT}?editProfile=true`)
  }

  const handleDocumentLoad = (detail) => {
    // Check if the form was already submitted
    if (detail?.completed_submitter?.completed_at) {
      goToSubmittedScreen()
    }
  }

  if (!docusealSlug) {
    return null
  }

  return (
    <ScreenContainer>
      <DocusealForm
        src={`https://docuseal.com/d/${docusealSlug}`}
        customCss={customCss}
        backgroundColor={COLOURS.neutralGrey1}
        onLoad={handleDocumentLoad}
        onComplete={goToSubmittedScreen}
        withTitle={false}
        withDecline={false}
        withDownload={false}
        allowToResubmit={false}
        withFieldNames={false}
        withDownloadButton={false}
        withSendCopyButton={false}
        sendCopyEmail
      />
    </ScreenContainer>
  )
}

export default ProtectSigning
